import {connect} from 'react-redux';
import TermsOfUse from './terms-of-use';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';

export default connect(null, {setNavigationAnnouncement})(TermsOfUse);
